import styled from "styled-components";
import { Link } from "react-router-dom";

export const StyledTab = styled(Link)<{ $isActive: boolean; $isDisabled?: boolean }>`
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    font-feature-settings: "tnum" on, "lnum" on;
    color: ${({ $isActive, theme }) =>
        $isActive ? theme.v2.colors["text-primary-900"] : theme.v2.colors["text-primary-700"]};
    margin: 0 8px;
    padding: 10px 14px;
    cursor: ${({ $isDisabled }) => ($isDisabled ? "default" : "pointer")};
    background-color: ${({ $isActive, theme }) => ($isActive ? theme.v2.colors["background-primary-50"] : "")};
    border-radius: 6px;
    letter-spacing: 0.007em;
    text-decoration: none;
`;

export const TextWrapper = styled.div<{ $isActive: boolean }>`
    display: flex;
    font-weight: ${props => (props.$isActive ? "600" : "500")};
    align-items: center;
    gap: 8px;
`;
